import { inject, Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpHandler,
    HttpEvent,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable({
    providedIn: 'root',
})
export class AuthTokenInterceptor implements HttpInterceptor {
    protected readonly userSvc = inject(UserService);

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const self = this;
        const authToken = self.userSvc?.User?.AuthToken;
        let headers = req.headers;

        if (authToken) {
            headers = headers.append('AuthToken', authToken);
        }

        const clonedReq = req.clone({ headers });

        return next.handle(clonedReq).pipe(
            catchError((err: HttpErrorResponse) => {
                const errmsg = this.GetErrorMessage(err);

                if (errmsg.includes('Session has expired')) {
                    this.userSvc.logout(false, 1);
                }

                if (err.error instanceof Blob) {
                    return throwError(err);
                }

                // Check for database issues.
                if (
                    errmsg &&
                    errmsg.includes &&
                    errmsg.includes('Execution Timeout Expired')
                ) {
                    // Yup, it's in the database. Clean up the error and pass it along.
                    return throwError(
                        'An error occurred in the database which prevented the request from succeeding. Please wait and try again.'
                    );
                }

                return throwError(err);
            })
        );
    }

    GetErrorMessage(error: HttpErrorResponse): string {
        let body = error?.error ?? error;
        let msg = '';

        if (body && body.errors && typeof body.errors === 'object') {
            const errobj = body.errors as any;
            const errkeys = Object.keys(errobj);

            msg = errkeys
                .map((k) => {
                    return errobj[k].toString();
                })
                .join('|');
        } else if (body && body.error) {
            body = body.error;

            msg =
                body.ExceptionMessage ||
                body.Message ||
                body.message ||
                body ||
                'An unknown error has occurred';
        } else {
            msg =
                body.ExceptionMessage ||
                body.Message ||
                body.message ||
                body ||
                'An unknown error has occurred';
        }

        return msg;
    }
}
